import { useQuery } from '@tanstack/react-query';

import { fetchDemoPersonas } from '../api/demoApi';

export const demoPersonasKey = ['demo', 'personas'] as const;

/**
 * Jedno pytanie na życie karty: tenant nie zmienia rodzaju w trakcie sesji,
 * a persony zmienia dopiero seed/reset — czyli i tak pełne przeładowanie.
 */
export function useDemoPersonas() {
  return useQuery({
    queryKey: demoPersonasKey,
    queryFn: ({ signal }) => fetchDemoPersonas(signal),
    staleTime: Infinity,
    retry: false,
  });
}
